<script>
import DatePicker from 'vue-datepicker-next';
import { useLocale } from 'shared/composables/useLocale';
import zhCn from 'vue-datepicker-next/locale/zh-cn.es';
import zhTw from 'vue-datepicker-next/locale/zh-tw.es';
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change'],
  setup() {
    const { resolvedLocale } = useLocale();

    return { resolvedLocale };
  },
  computed: {
    pickerLang() {
      const normalizedLocale = this.resolvedLocale?.toLowerCase();

      if (normalizedLocale?.startsWith('zh-tw')) {
        return zhTw;
      }

      if (normalizedLocale?.startsWith('zh')) {
        return zhCn;
      }

      return normalizedLocale || 'en';
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      range
      confirm
      :clearable="false"
      :editable="false"
      :lang="pickerLang"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      @change="handleChange"
    />
  </div>
</template>
